// /opt/isp_erp/frontend/src/api/ftth.api.js
import axios from './axios';

export const ftthAPI = {
  // NAPs
  getNaps: async (params = {}) => {
    const response = await axios.get('/ftth/naps', { params });
    return response.data;
  },

  getNapById: async (id) => {
    const response = await axios.get(`/ftth/naps/${id}`);
    return response.data;
  },

  createNap: async (data) => {
    const response = await axios.post('/ftth/naps', data);
    return response.data;
  },

  updateNap: async (id, data) => {
    const response = await axios.put(`/ftth/naps/${id}`, data);
    return response.data;
  },

  // ✅ ACTUALIZADO: ahora acepta force y borrar_geo
  deleteNap: async (id, force = false, borrarGeo = true) => {
    const response = await axios.delete(`/ftth/naps/${id}`, {
      params: {
        ...(force ? { force: true } : {}),
        borrar_geo: borrarGeo,
      },
    });
    return response.data;
  },

  getNapsNearby: async (lat, lng, radiusKm = 1) => {
    const response = await axios.get('/ftth/naps/nearby', {
      params: { lat, lng, radius_km: radiusKm },
    });
    return response.data;
  },

  // Puertos
  getPuertosByNap: async (napId, estado = null) => {
    const params = estado ? { estado } : {};
    const response = await axios.get(`/ftth/naps/${napId}/puertos`, { params });
    return response.data;
  },

  asignarPuerto: async (data) => {
    const response = await axios.post('/ftth/asignar-puerto', data);
    return response.data;
  },

  liberarPuerto: async (puertoId) => {
    const response = await axios.post(`/ftth/liberar-puerto/${puertoId}`);
    return response.data;
  },

  getClientesByNap: async (napId) => {
    const response = await axios.get(`/ftth/naps/${napId}/clientes`);
    return response.data;
  },
};
